function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { generateNumericRangeSuggestions } from '../../utils';
import Range from '../range/Range';
import { ICON_CURRENCY_EUR } from '../../icons';
const formatter = new Intl.NumberFormat('it-IT');
const printPriceRangeFormattedValue = value => `€ ${formatter.format(value)}`;
const printPriceRangeValue = value => formatter.format(parseInt(value, 10));
const printPriceRangeSuggestion = suggestion => suggestion.label;
export const PRICE_RANGE_DEFAULT_SUGGESTIONS = [...generateNumericRangeSuggestions(6, 10000, 50000, printPriceRangeFormattedValue), ...generateNumericRangeSuggestions(15, 20000, 120000, printPriceRangeFormattedValue), ...generateNumericRangeSuggestions(12, 50000, 450000, printPriceRangeFormattedValue), ...generateNumericRangeSuggestions(4, 250000, 1250000, printPriceRangeFormattedValue)];
export const PriceRange = _ref => {
  let {
    minSuggestions = PRICE_RANGE_DEFAULT_SUGGESTIONS,
    maxSuggestions = PRICE_RANGE_DEFAULT_SUGGESTIONS,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Range, _extends({
    step: 1000,
    icon: ICON_CURRENCY_EUR,
    minSuggestions: minSuggestions,
    maxSuggestions: maxSuggestions
  }, rest, {
    printValue: printPriceRangeValue,
    printSuggestion: printPriceRangeSuggestion
  }));
};
export default PriceRange;
//# sourceMappingURL=PriceRange.js.map